import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IMeetingByOperatorPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const meetingByOperatorSlice = createSlice({
    name: 'meeting-statistics/meeting-by-operator',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingByOperatorPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingByOperatorActions = meetingByOperatorSlice.actions
export default meetingByOperatorSlice.reducer
